/* eslint-disable react/require-default-props */
import React, { lazy, Suspense } from 'react';
import type { SxProps } from '@mui/material';
import type{ FinancialsConfigureModalProps } from './FinancialsConfigureModal';
import { FinancialsConfigureState } from '../services/financials.service';
import { loadFederatedModule } from '../../../utils/loadFederatedModule';

/* FinancialsChartModal */
type FinancialsChartModalProps = {
  open?: boolean;
  onClose?: () => void;
  onUpdate?: () => void;
  onDelete?: () => void;
  sx?: SxProps;
  baseUrl?: string;
  initialValues?: Partial<FinancialsConfigureState>;
  externalSourceId?: number; // external object id
  externalCostBudgetResources?: {
    budget?: number;
    resources?: number;
    runningCost?: number;
  };
  financialConfigureModalRenderChildren?: FinancialsConfigureModalProps['renderChildren'];
  objectId: number; // objective id or keyResult id
  objectType: number; // 1: objective, 2: keyResult
  entityId?: number; // financials entity id
  isModal?: boolean;
  onTrackEvent?: (eventName: string, props: Record<string, unknown>) => void;
  trackingLocation?: string;
};

const FinancialsChartModalLazy = lazy(
  async () => loadFederatedModule<typeof import('OKR/FinancialsChartModal')>('OKR/FinancialsChartModal'),
);

export const FinancialsChartModal = (props: FinancialsChartModalProps) => (
  <Suspense fallback={null}>
    <FinancialsChartModalLazy {...props} />
  </Suspense>
);
